export default __webpack_public_path__ + "static/service_ap3-9e8ab407804a49692123179987e219d3.png";